import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SeguridadService} from "@servicios/Seguridad.service";

const ROUTES: Routes =
    [
        {path: 'inicio', loadChildren: () => import('@contenido/LandingPage/LaddingPage.module').then(m => m.LaddingPageModule)},
        {path: 'evaluacionexterno', loadChildren: () => import('@contenido/EvaluacionExterno/evaluacionexterno.module').then(m => m.EvaluacionExternoModule)},
        {path: 'app', loadChildren: () => import('@contenido/contenido.module').then(m => m.ContenidoModule), data: {}, canLoad: [SeguridadService]},
        {path: '**', redirectTo: 'inicio', pathMatch: 'full'},
    ];

@NgModule({
    imports: [RouterModule.forRoot(ROUTES, { useHash: false })],
    exports: [RouterModule]
})

export class AppRoutingModule {}
